/**
 * v2 StatPill — colored status pill (good / warn / danger / info / neutral / accent).
 * Matches prototype widgets.jsx <StatPill> spec: 4px radius, 11px font, 600 weight.
 */

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type StatPillTone = "good" | "warn" | "danger" | "info" | "neutral" | "accent";

interface StatPillProps {
  tone?: StatPillTone;
  children: ReactNode;
  className?: string;
}

const TONE_STYLES: Record<StatPillTone, string> = {
  good: "bg-[var(--v2-good-soft)] text-[var(--v2-good)]",
  warn: "bg-[var(--v2-warn-soft)] text-[var(--v2-warn)]",
  danger: "bg-[var(--v2-danger-soft)] text-[var(--v2-danger)]",
  info: "bg-[var(--v2-info-soft)] text-[var(--v2-info)]",
  neutral: "bg-muted text-muted-foreground",
  accent: "bg-accent text-accent-foreground",
};

export function StatPill({ tone = "neutral", children, className }: StatPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-semibold",
        TONE_STYLES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
